import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  private callback:any;
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(DOCUMENT) private document: any) { 
      
      this.callback = data.callback;
  }

  ngOnInit() {
  }

  onConfirmClick():void{
    if(this.data.action === 'retire') {
      this.dialogRef.close({
        confirmed: true,
        action: this.data.action
      });
    } else if(this.data.action === 'restore') {
      this.dialogRef.close({
        confirmed: true,
        action: this.data.action
      });
    } else {
      this.callback();
      this.dialogRef.close();
    }

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/confirmation-dialog/confirmation-dialog.component.ts